import { MetadataEntitiesClient, MetadataEntityCreateRequest, MetadataEntityType } from "@api/apiClient";
import axios from "@api/axiosInstance";
import { useMutation, useQuery } from "@tanstack/react-query";

const nonModelledClient = new MetadataEntitiesClient(undefined, axios);

export const useNonModelledMaterials = (type: string, options?: any) => {
  return useQuery<string[]>({
    ...options,
    queryKey: ["modelFamily", type],
    initialData: [],
    queryFn: async () => {
      return nonModelledClient.getMetaDataByType(type);
    },
  });
};

export const useDeleteNonModelledMaterials = (options?: any) => {
  return useMutation<boolean, unknown, { id: string; }>({
    ...options,
    mutationFn: ({ id }) => nonModelledClient.deleteMetaDataEntitybyId(id),
  });
};


export const useAddNonModelledMaterials = (type: string, options?: any) => {
  return useMutation<{ type: string; value: string; }, unknown, { value: string; }>({
    ...options,
    mutationFn: ({ value }) => {
      var createRequest = new MetadataEntityCreateRequest({
        name: value as string,
        type: type,
      });
      return nonModelledClient.createMetaDataEntity(createRequest);
    },
  });
};

export const useAddNonModelledFamilyType = (options?: any) => {
  return useMutation<any, unknown, { ModelFamilyId: string; ModelFamilyTypeList: string[]; }>({
    ...options,
    mutationFn: async ({ ModelFamilyId, ModelFamilyTypeList }) => {
      const createRequests = ModelFamilyTypeList.map(familyType => {
        return new MetadataEntityCreateRequest({
          name: familyType,
          parentId: ModelFamilyId,
          type: MetadataEntityType.ModelFamilyType
        });
      });

      return nonModelledClient.createModelFamilyTypeEntity(createRequests);
    },
  });
};